import './joined-organisation.scss';
/* @ngInject */
export default class IntermediaryPageJoinedOrganisationController {
    constructor($stateParams, IntermediaryPageService) {
        this.token = $stateParams.token;
        this.isAdminAreaUser = $stateParams.isAdminAreaUser;
        this.organisation = $stateParams.organisation;
        this.role = $stateParams.role;
        this.hostUrl = IntermediaryPageService.getHostUrl();
        this.displayHostUrl = IntermediaryPageService.getDisplayHostUrl();
    }

    $onInit() {}
}
